import { render } from "./BankMerchants.vue?vue&type=template&id=75e4a10c"
import script from "./BankMerchants.vue?vue&type=script&lang=js"
export * from "./BankMerchants.vue?vue&type=script&lang=js"

import "./BankMerchants.vue?vue&type=style&index=0&id=75e4a10c&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__